export const KYC_LEVEL_LIMITS = [
  {
    level: 1,
    trading: "1K",
    tradingRaw: 1000,
    withdrawal: "100",
    withdrawalRaw: 100,
  },
  {
    level: 2,
    trading: "10K",
    tradingRaw: 10000,
    withdrawal: "500",
    withdrawalRaw: 500,
  },
  {
    level: 3,
    trading: "25K",
    tradingRaw: 25000,
    withdrawal: "1K",
    withdrawalRaw: 1000,
  },
] as const;

export const KYC_LIMIT_LABELS = {
  tradingSubtitle: "One-time Payout",
  withdrawalSubtitle: "Daily Withdrawal",
} as const;
